import * as actions from '../actions/tabActions';
import { getCMSConfiguration } from '../cms/cmsLib';

export const initialState = {
   selectedTab: {},
};

export default function postsReducer(state = initialState, action) {
   switch (action.type) {
      case actions.SET_HOTELS_TAB:
            return { ...state, selectedTab: getHotelsTab() };
      case actions.CLEAN_HOTELS_TAB:
            return { ...state, selectedTab: {} }
      default:
         return state;
   }
}

function getHotelsTab() {

   const selectedTab = JSON.parse(localStorage.getItem('selectedTab'));

   // If the tab hotel is the current selected, return it.
   if ( selectedTab.type.id === 'H' ) {
      return {...selectedTab};
   }

   const cmsConfiguration = getCMSConfiguration();
   
   // If no has the tabs property return default
   if ( !cmsConfiguration.hasOwnProperty('tabs') ) {
      return defaultHotelTab();
   }
   const hotelsTab = cmsConfiguration.tabs.find( tab => tab.type.id === 'H');

   if ( hotelsTab ) {
      return {...hotelsTab};
   }

   // This is some default tab for hotels when the agency has not setted one.
   return defaultHotelTab();
}

function defaultHotelTab() {
   return {
      label: { key: 'title', value: 'Hoteles' },
      name: '',
      orden: 1,
      type: { id: 'H', name: 'Hoteles' }
   }
}


// WEBPACK FOOTER //
// ./src/reducers/tabsReducer.js